import { getBasePathFromLocation, normalizeBasePath } from './basePath';

const basePath = normalizeBasePath(getBasePathFromLocation(), { trailingSlash: true });
const origin = typeof window !== 'undefined' && window.location ? window.location.origin : '';

// Set webpack runtime public path before any lazy-loaded imports execute.
__webpack_public_path__ = `${origin}${basePath}`;
